<template>
  <div ref="sliderLine" class="minSliderLine d-flex flex-column rounded-lg justify-space-between align-center">
    <v-btn small icon :disabled="!isCarousel && (positionI === 0)" class="icon mb-1" @click="up">
      <v-icon class="uikit-icon chevron-left-circle" :class="!isCarousel && (positionI === 0) ? 'greylighten1' : ''" />
    </v-btn>
    <div ref="slider" class="d-flex overflow-hidden rounded-lg">
      <div ref="sliderBody" class="d-flex flex-column anim">
        <div
          v-for="(item,i) in items"
          :key="i"
          class="anim py-1 new-card"
          @click="+$route.query.idNew !== +item.id && $router.push({ path: '/spm/news', query: { idNew: item.id } })"
        >
          <v-img
            class="rounded-lg black-mask"
            :src="item.src"
            :height="height"
            :width="imgWidth"
          >
            <div class="ml-2 mt-2 text-img">
              {{ item.text }}
            </div>
            <template #placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular indeterminate color="grey lighten-5" />
              </v-row>
            </template>
          </v-img>
        </div>
      </div>
    </div>

    <v-btn small icon :disabled="!isCarousel && (positionI + showElements === items.length)" class="icon mt-1" @click="down">
      <v-icon class="uikit-icon chevron-right-circle" :class="!isCarousel && (positionI + showElements === items.length) ? 'greylighten1' : ''" />
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'UISliderLine',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 160,
    },
    width: {
      type: Number,
      default: 200,
    },
    isCarousel: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.$nextTick(() => {
      const fun = () => {
        if (this.$refs?.sliderLine?.clientWidth) {
          this.showElements = Math.floor((this.$refs?.sliderLine?.clientHeight - 60) / this.height)
          this.imgWidth = this.$refs?.sliderLine?.clientWidth || this.width

          this.positionI = 0
          this.$refs.sliderBody.style.transform = 'translateX(0px)'
        } else this.imgWidth = this.width
      }

      this.observer = new ResizeObserver(fun)

      if (this.$refs?.sliderLine) {
        this.observer.observe(this.$refs?.sliderLine)
      }
    })
  },

  destroyed() {
    if (this.$refs?.sliderLine) {
      this.observer.disconnect()
    }
  },

  data: () => ({
    showElements: 0,
    positionI: 0,
    imgWidth: 200,
    observer: null,
  }),

  methods: {
    down() {
      if (this.$refs.slider) {
        if (this.positionI + this.showElements < this.items.length) this.positionI += 1
        else if (this.isCarousel) this.positionI = 0

        const translateY = -(this.height * this.positionI + (this.positionI * 8))
        this.$refs.sliderBody.style.transform = `translateY(${translateY}px)`
      }
    },

    up() {
      if (this.$refs.slider) {
        if (this.positionI > 0) this.positionI -= 1
        else if (this.isCarousel) this.positionI += this.showElements - 1

        const translateY = -(this.height * this.positionI + (this.positionI * 8))
        this.$refs.sliderBody.style.transform = `translateY(${translateY}px)`
      }
    },
  },
}
</script>

<style scoped lang="scss">
.black-mask:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

.text-img {
  z-index: 10;
  position: absolute;
  color: white;
}

.anim {
  transition-duration: 0.6s;
}

.new-card:hover {
  cursor: pointer;
}

.black-mask {
  background: linear-gradient(-45deg, rgba(100,115,201,.33), rgba(25,32,72,.7)) !important;
  background-size: 200% 200% !important;
  animation: gradient 10s ease infinite !important;
}

.icon {
  transform: rotate(90deg);
}

@keyframes gradient {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
